import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { getTenantId } from "../helper";
import { IGetMenuResponse, MenuModel } from "../models/menu/Menu";
import { AppMenuOrderingRequest } from "../models/menu/request/AppMenuOrderingRequest";
let MenusModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let MenusModule = class MenusModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.menus = [];
            this.menu = new MenuModel();
            this.pages = [];
            this.nodes = [];
        }
        async GetMenu() {
            var url = `${getTenantId()}/Menu`;
            let { data } = await service.get(url);
            if (data) {
                this.SetPages(data);
            }
            return [];
        }
        SetPages(data) {
            this.pages = data.pages;
            this.menus = data.menus;
        }
        async AddMenu(newMenu) {
            var url = `${getTenantId()}/Menu`;
            if (newMenu.data.pageElementId == "") {
                newMenu.data.pageElementId = null;
            }
            let { data } = await service.post(url, newMenu);
            if (data) {
                return data;
            }
        }
        async UpdateMenu(updateMenu) {
            var url = `${getTenantId()}/Menu`;
            if (updateMenu.data.pageElementId == "") {
                updateMenu.data.pageElementId = null;
            }
            let { data } = await service.put(url, updateMenu);
            if (data) {
                return data;
            }
        }
        async DeleteMenu(menuId) {
            var url = `${getTenantId()}/Menu/` + menuId + `/delete`;
            let { data } = await service.post(url);
            if (data) {
                this.SetDeleteMenu(data.menuId);
                return data;
            }
        }
        SetDeleteMenu(menuId) {
            const index = this.pages
                .map(function (array) {
                return array.id;
            })
                .indexOf(menuId, 0);
            if (index > -1) {
                this.pages.splice(index, 1);
            }
        }
        async UpdateMenuOrdering(request) {
            var url = `${getTenantId()}/Menu/menuOrdering`;
            let { data } = await service.put(url, request);
            if (data) {
                return data;
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], MenusModule.prototype, "GetMenu", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IGetMenuResponse !== "undefined" && IGetMenuResponse) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], MenusModule.prototype, "SetPages", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof MenuModel !== "undefined" && MenuModel) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], MenusModule.prototype, "AddMenu", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof MenuModel !== "undefined" && MenuModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], MenusModule.prototype, "UpdateMenu", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], MenusModule.prototype, "DeleteMenu", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MenusModule.prototype, "SetDeleteMenu", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof AppMenuOrderingRequest !== "undefined" && AppMenuOrderingRequest) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], MenusModule.prototype, "UpdateMenuOrdering", null);
    MenusModule = __decorate([
        Module({ dynamic: true, store: store, name: "Menu", namespaced: true })
    ], MenusModule);
    return MenusModule;
})();
export const MenuModule = getModule(MenusModule);
